import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "27",
  fill: "none",
  viewBox: "0 0 25 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"#000\" stroke-miterlimit=\"10\" clip-path=\"url(#purchase-on-invoice-mobile_svg__a)\"><path stroke-linejoin=\"round\" d=\"M18.5 10.5V1.62H2v24.84h16.5V21.5M3.9 4.968h12.6M3.9 8.856h12.6M3.9 12.744h12.6M3.9 21.276h7.2\"></path><path d=\"m15.829 20.747-2.194.595.464-2.187 7.045-7.652 1.73 1.593zM22.005 14.039l-1.73-1.592\"></path></g><defs><clipPath id=\"purchase-on-invoice-mobile_svg__a\"><path fill=\"#fff\" d=\"M0 0h25v27H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }